import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useUI } from '../../context/UIContext';
import { IconWhatsapp } from './Icons';

// Two-step WhatsApp OTP login used by the storefront account page and the admin panel.
export default function OtpLogin({ onSuccess, title = 'Log in with WhatsApp', subtitle = 'We will send a one-time password to your WhatsApp number.' }) {
  const { requestOtp, verifyOtp } = useAuth();
  const { toast } = useUI();
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [devOtp, setDevOtp] = useState('');
  const [countdown, setCountdown] = useState(0);

  const startCountdown = (s) => {
    setCountdown(s);
    const t = setInterval(() => setCountdown((c) => {
      if (c <= 1) { clearInterval(t); return 0; }
      return c - 1;
    }), 1000);
  };

  const send = async (e) => {
    if (e) e.preventDefault();
    setBusy(true);
    try {
      const r = await requestOtp(phone);
      setDevOtp(r.devOtp || '');
      toast(r.message);
      setStep(2);
      startCountdown(45);
    } catch (err) {
      toast(err.message, 'error');
    } finally {
      setBusy(false);
    }
  };
  const verify = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await verifyOtp(phone, otp, name);
      toast(`Welcome${user.name ? `, ${user.name}` : ''}!`);
      if (onSuccess) onSuccess(user);
    } catch (err) {
      toast(err.message, 'error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="eg-otp">
      <div className="flex items-center justify-center mb-2 text-green-600"><IconWhatsapp width={36} height={36} /></div>
      <h2 className="text-2xl font-medium text-center mb-1">{title}</h2>
      <p className="text-color-secondary text-center mb-6 text-sm">{subtitle}</p>
      {step === 1 ? (
        <form onSubmit={send}>
          <label className="block text-sm mb-1 font-medium">WhatsApp number (with country code)</label>
          <input className="form-control w-full mb-4" placeholder="e.g. 919876543210" value={phone} onChange={(e) => setPhone(e.target.value.replace(/[^\d+]/g, ''))} required inputMode="tel" autoFocus />
          <button type="submit" className="sf__btn sf__btn-primary w-full" disabled={busy}>{busy ? 'Sending…' : 'Send OTP on WhatsApp'}</button>
        </form>
      ) : (
        <form onSubmit={verify}>
          <p className="text-sm mb-3">OTP sent to <strong>+{phone.replace(/\D/g, '')}</strong> <button type="button" className="underline ml-1" onClick={() => setStep(1)}>change</button></p>
          {devOtp && <p className="eg-dev-otp">Development mode – your OTP is <strong>{devOtp}</strong></p>}
          <input className="form-control w-full mb-3 text-center text-2xl tracking-[0.5em]" placeholder="••••••" value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))} maxLength={6} inputMode="numeric" required autoFocus />
          <input className="form-control w-full mb-4" placeholder="Your name (optional, for new accounts)" value={name} onChange={(e) => setName(e.target.value)} />
          <button type="submit" className="sf__btn sf__btn-primary w-full" disabled={busy || otp.length < 6}>{busy ? 'Verifying…' : 'Verify & log in'}</button>
          <button type="button" className="block mx-auto mt-3 text-sm underline disabled:opacity-50" disabled={countdown > 0 || busy} onClick={() => send()}>
            {countdown > 0 ? `Resend OTP in ${countdown}s` : 'Resend OTP'}
          </button>
        </form>
      )}
    </div>
  );
}
